import { callInternalApi } from "../hooks/API/useCallInternal";

export async function markEventRead(noteId) {
  await callInternalApi(
    `my/events/markEventRead?noteId=${encodeURIComponent(noteId)}`
  );
}
